import AgoraRTC, { AgoraRTCProvider } from 'agora-rtc-react';
import { createContext, useContext, useMemo, useState } from 'react';

// const AgoraContext = createContext(null);

// export const useAgoraContext = () => useContext(AgoraContext);

// export default function AgoraProvider({ children }) {
//   const [mode, setMode] = useState('live');

//   const client = useMemo(() => AgoraRTC.createClient({ mode, codec: 'vp8' }), [mode]);

//   return (
//     <AgoraContext.Provider value={{ client, mode, setMode }}>
//       <AgoraRTCProvider client={client}>{children}</AgoraRTCProvider>
//     </AgoraContext.Provider>
//   );
// }

export const client = AgoraRTC.createClient({ mode: 'live', codec: 'vp8' });

export default function AgoraProvider({ children }) {
  return <AgoraRTCProvider client={client}>{children}</AgoraRTCProvider>;
}
